// Make sure to call Vue.use(Vuex) first if using a module system
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
		user: null,
		statusInfo: null,
		todayMetrics: null,
	},
	mutations: {
		setUser(state, user) {
			state.user = user
		},
		setStatusInfo(state, statusInfo) {
			state.statusInfo = statusInfo
		},
		getTodayMetrics(state, todayMetrics) {
			state.todayMetrics = todayMetrics
		},
	},
	actions: {
		setUser({state, commit}, user) {
			commit('setUser', user)
		},
		setStatusInfo({state, commit}, statusInfo) {
			commit('setStatusInfo', statusInfo)
		},
		getTodayMetrics({state, commit}, todayMetrics) {
			commit('getTodayMetrics', todayMetrics)
		},
	},
	getters: {
		
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js